import React from 'react';
import styled from '@emotion/styled';
import { rem } from 'polished';
import { text, colors } from '../../core/styles/theme/default';
import Spacer from '../../helpers/Spacer';
import { Link } from '../../primitives';

const StyledPublication = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  cursor: pointer;
`;

const StyledPublicationImage = styled.div`
  display: block;
  width: 100%;
  padding-bottom: 56.25%;
  position: relative;
  background: linear-gradient(
    90deg,
    rgba(37, 55, 100, 0.9) 0%,
    rgba(37, 55, 100, 0.6) 100%
  );
`;

const StyledPublicationContent = styled.div`
  border: ${rem(1)} solid ${colors.grue300};
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: ${rem(32)} ${rem(24)};
  border-radius: 0 0 4px 4px;
`;

const StyledPublicationTitle = styled.p`
  ${text.p2}
  color: ${colors.blue900};
`;

const StyledImage = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 50%;
  font-family: 'object-fit: cover; object-position: 50% 50%';
`;

const StyledLink = styled(Link)`
  margin-top: auto;
  color: ${colors.nightBlue500};
`;

const TeaserAusAltMachNeu = ({
  data: { Id, Title, ImageAfterName, seeDetailsText, lang },
}: TeaserAusAltMachNeuProps) => {
  const href = `/${lang}/tools/aus-alt-mach-neu-details?id=${Id}`;

  return (
    <>
      <StyledPublication
        data-id={'publicationId'}
        onClick={() => (window.location.href = href)}
      >
        <StyledPublicationImage>
          <StyledImage src={ImageAfterName} />
        </StyledPublicationImage>
        <StyledPublicationContent>
          <StyledPublicationTitle>{Title}</StyledPublicationTitle>
          <Spacer space="gamma" />
          <StyledLink
            linkText={seeDetailsText}
            link={{
              href,
              title: seeDetailsText,
            }}
            iconBefore="AnimatedIconArrowRight"
            className="animate"
          />
        </StyledPublicationContent>
      </StyledPublication>
    </>
  );
};

type TeaserAusAltMachNeuProps = {
  data: {
    Id: string;
    Title: string;
    ImageAfterName: string;
    seeDetailsText: string;
    lang: string;
  };
};

export default TeaserAusAltMachNeu;
